<span [innerHTML]="content"></span>